export const sanitizeUrl = (url) => url.startsWith("~") ? url.slice(1) : url;
